import React from 'react';
import clsx from 'clsx';
const initials = (name) => {
    const [firstName, lastName] = name.split(' ');
    return firstName && lastName
        ? `${firstName.charAt(0)}${lastName.charAt(0)}`
        : firstName.charAt(0);
};
export const avatarSizeClasses = {
    xs: 'h-6 w-6',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
    '2xl': 'h-24 w-24',
    '3xl': 'h-32 w-32',
};
export const Avatar = props => {
    const { size = 'md', rounded = 'full', src, name, icon, className, style, } = props;
    const sizeClsx = {
        'w-5 h-5': size === 'xxs',
        'h-6 w-6 ': size === 'xs',
        'h-8 w-8': size === 'sm',
        'h-10 w-10': size === 'md',
        'h-12 w-12': size === 'lg',
        'h-16 w-16': size === 'xl',
        'h-24 w-24': size === '2xl',
        'h-32 w-32': size === '3xl',
    };
    const sizeInPixel = {
        xxs: 20,
        xs: 24,
        sm: 32,
        md: 40,
        lg: 48,
        xl: 64,
        '2xl': 96,
        '3xl': 128,
    };
    const iconSizeClsx = {
        'h-1 w-1': size === 'xxs',
        'h-1.5 w-1.5': size === 'xs',
        'h-2 w-2': size === 'sm',
        'h-3 w-3': size === 'md',
        'h-3.5 w-3.5': size === 'lg',
        'h-4 w-4 ': size === 'xl',
        'h-5 w-5 ': size === '2xl',
        'h-6 w-6 ': size === '3xl',
    };
    const roundedClsx = {
        'rounded-sm': rounded === 'sm',
        'rounded-md': rounded === 'md',
        'rounded-full': rounded === 'full',
    };
    if (!src) {
        if (name) {
            return (React.createElement("span", { className: clsx('inline-flex relative items-center justify-center flex-shrink-0 bg-surface-pressed', roundedClsx, sizeClsx, className), style: style },
                React.createElement("span", { translate: "no", className: `text-${size} font-medium leading-none text-content-subdued` }, name ? initials(name) : null),
                icon && (React.createElement("div", { className: clsx('absolute bottom-0 end-0 ', iconSizeClsx) }, icon))));
        }
        return (React.createElement("span", { className: clsx('inline-block relative bg-surface-pressed flex-shrink-0', roundedClsx, sizeClsx, className) },
            React.createElement("span", { className: clsx('inline-block overflow-hidden ', roundedClsx, sizeClsx) },
                React.createElement("svg", { className: "h-full w-full text-content-on-inverse-focused", fill: "currentColor", viewBox: "0 0 24 24" },
                    React.createElement("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" }))),
            icon && (React.createElement("div", { className: clsx('absolute bottom-0 end-0 ', iconSizeClsx) }, icon))));
    }
    return (React.createElement("span", { className: "inline-block relative flex-shrink-0" },
        React.createElement("img", { className: clsx('bg-surface inline-block object-cover object-center', roundedClsx, sizeClsx, className), height: sizeInPixel[size] || 40, width: sizeInPixel[size] || 40, src: src, alt: name }),
        icon && (React.createElement("div", { className: clsx('absolute bottom-0 end-0 ', iconSizeClsx) }, icon))));
};
//# sourceMappingURL=Avatar.js.map